// @ts-expect-error
export default {
  wordBreak: 'break-all',
  display: 'inline-block',
  maxWidth: '100%'
};
//# sourceMappingURL=isLongStyles.js.map